import { useEffect, useRef, useState } from "react";
import { TiArrowUp } from "react-icons/ti";
import { hightlightsSlides } from "../constants";
import Features from "./Features";
import Footer from "./Footer";
import Hero from "./Hero";
import Highlights from "./Highlights";
import HowItWorks from "./HowItWorks";
import Model from "./Model";

const Home = () => {
  const [isBottom, setIsBottom] = useState(false);
  const scrollTopRef = useRef(null);

  const checkIfBottom = () => {
    if (
      window.innerHeight + window.scrollY >=
      document.body.offsetHeight - 200
    ) {
      setIsBottom(true);
    } else {
      setIsBottom(false);
    }
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  useEffect(() => {
    window.addEventListener("scroll", checkIfBottom);
    return () => {
      window.removeEventListener("scroll", checkIfBottom);
    };
  }, []);

  return (
    <div className="w-screen min-h-screen bg-black text-blue-50">
      <Hero />
      <Highlights slides={hightlightsSlides} />
      <Model />
      <Features />
      <HowItWorks />
      <Footer />

      {/* Back to Top Button */}
      {isBottom && (
        <div
          ref={scrollTopRef}
          className="fixed bottom-10 left-5 flex items-center gap-3 px-5 py-3 bg-black/40 backdrop-blur-sm border border-cyan-500/30 rounded-full shadow-lg shadow-cyan-500/10 cursor-pointer hover:bg-black/60 hover:border-cyan-400/50 transition-all duration-500 z-50"
          onClick={scrollToTop}
          aria-label="Back to Top"
        >
          <TiArrowUp className="text-cyan-400 transition-all duration-500" size={24} />
          <span className="relative z-20 text-sm uppercase text-white/80 font-medium tracking-wider transition-colors duration-500 hover:text-white">
            BACK TO TOP
          </span>
        </div>
      )}
    </div>
  );
};

export default Home;
